import { Box, Button, FlexBox, Icon, Typography, useScreenClass } from '@vp/swan';
import { Price } from '@99designs/pricing';
import { useChatActions } from '../contexts/ChatContext';

export interface BriefReadyCardProps {
    onReview: () => void;
    onContinue?: () => void;
}

export function BriefReadyCard({ onReview, onContinue }: BriefReadyCardProps) {
    const { productName, productPrice } = useChatActions();
    const screenClass = useScreenClass();
    const isMobile = screenClass === 'xs';

    return (
        <Box
            style={{
                backgroundColor: 'var(--swan-sem-color-bg-active)',
                border: '1px solid var(--swan-sem-color-border-standard)',
                borderBottom: 'none',
                padding: 'var(--swan-sem-space-6)',
                borderRadius:
                    'var(--swan-sem-border-radius-standard) var(--swan-sem-border-radius-standard) 0 0',
            }}
        >
            {/* Header */}
            <FlexBox
                flexDirection={isMobile ? 'column' : 'row'}
                alignItems={isMobile ? 'flex-start' : 'center'}
                justifyContent="space-between"
                gap={3}
                mb={5}
            >
                <Typography fontSkin="title-subsection">
                    Review your brief and place your order
                </Typography>
                {productName && productPrice && (
                    <FlexBox alignItems="center" gap={2} style={{ flexShrink: 0 }}>
                        <Typography fontSkin="body-standard-bold">{productName}</Typography>
                        <Typography fontSkin="title-subsection">
                            <Price price={productPrice} />
                        </Typography>
                    </FlexBox>
                )}
            </FlexBox>
            {/* Process steps */}
            <Box as="ol" style={{ margin: 0, paddingLeft: 'var(--swan-sem-space-5)' }}>
                <Typography as="li" fontSkin="body-standard" mb={2}>
                    Review your brief to make sure everything looks right.
                </Typography>
                <Typography as="li" fontSkin="body-standard" mb={5}>
                    Checkout to start your project, and a designer will begin once payment is
                    complete.
                </Typography>
            </Box>

            <FlexBox
                flexDirection={isMobile ? 'column' : 'row'}
                gap={4}
                alignItems={isMobile ? 'stretch' : 'center'}
            >
                {/* Review button */}
                <Button
                    skin="primary"
                    iconPosition="left"
                    onClick={onReview}
                    style={isMobile ? { width: '100%' } : undefined}
                >
                    <Icon iconType="invoice" size="small" />
                    Review and checkout
                </Button>
                {onContinue && (
                    <Button
                        skin="secondary"
                        iconPosition="left"
                        onClick={onContinue}
                        style={isMobile ? { width: '100%' } : undefined}
                    >
                        <Icon iconType="aiSupport" size="small" />
                        Continue chat
                    </Button>
                )}
            </FlexBox>
        </Box>
    );
}
